@if (!formIsReady) {
<div>Loading Roles...</div>
} @else {
<div [formGroup]="iamRolesForm">
    <mat-label>Roles</mat-label><br>
    @for (iamRole of iamRoles; track iamRole.long_role_name) {
    <mat-checkbox formControlName="{{iamRole.long_role_name}}">
        <b>{{iamRole.short_role_desc}}</b> - {{iamRole.long_role_desc}}
    </mat-checkbox><br>
    }
</div>
}